import React from 'react';
import { ImageFile } from '~/data/types/images';

const CirclePlaneImageIcon: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      className={className}
      style={style}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 297 74"
    >
      <path
        d="M80.372 63.2736C116.221 73.418 133.303 8.41315 165.72 17.418C201.72 27.418 159.624 61.4431 168.894 40.6836C177.72 20.918 271.221 89.418 294.441 23.2188M80.372 63.2736L71.1318 25.4199M80.372 63.2736L65.8718 36.5248M80.372 63.2736L54.0619 55.9793M71.1318 25.4199L85.5921 2.53668C85.7679 2.2586 85.4496 1.89494 85.1474 2.02853L2 38.7863M71.1318 25.4199L2 38.7863M2 38.7863L44.2953 71.3412C44.4573 71.4659 44.6803 71.4334 44.7791 71.2707L54.0619 55.9793M2 38.7863L65.8718 36.5248M65.8718 36.5248L54.0619 55.9793"
        stroke="#00D6D1"
        strokeWidth="4"
        strokeLinejoin="round"
      />
    </Component>
  );
};

export default CirclePlaneImageIcon;
